import React from 'react';
import { useController, UseControllerProps } from 'react-hook-form';
import { ControllerRenderProps } from 'react-hook-form';
import Upload, { ItemRender } from '@common/upload';
import Icon from '@common/assets';
import { profileBeforeUpload } from '@components/common/upload/beforeUpload';
import classnames from 'classnames/bind';
import styles from '../attachedFile.module.scss';
const cx = classnames.bind(styles);

const EmptyFiles = () => {
  return <div className={cx('infoText')}>pdf, ppt 파일 (50MB) 이하</div>;
};

const researchUploadItemRender: ItemRender = (originNode, { fileName }, fileList, { download, remove }) => {
  return (
    <div className={cx('fileListArea')}>
      <div className={cx('fileListWrap')}>
        <a className={cx('fileName')} role="button" onClick={download}>
          {fileName}
        </a>
        <a className={cx('btnFileDelete')} role="button" onClick={remove}>
          <Icon name="deleteLight" width={20} height={20} />
        </a>
      </div>
    </div>
  );
};

interface PortfolioUploadProps {
  attachFilesField: ControllerRenderProps;
}

const PortfolioUpload = ({ attachFilesField }: PortfolioUploadProps) => {
  return (
    <Upload
      {...attachFilesField}
      itemRender={researchUploadItemRender}
      labelClassName={cx('fileLabel')}
      multiple
      notice={!attachFilesField.value?.length && <EmptyFiles />}
      accepts={['.ppt', '.pptx', '.pdf']}
      beforeUpload={profileBeforeUpload}
    >
      첨부파일을 추가해주세요.
      <span className={cx('icon')} />
    </Upload>
  );
};

type CareerAttachFilesProps = UseControllerProps;

const CareerAttachFiles = (props: CareerAttachFilesProps) => {
  const { field: attachFilesField } = useController(props);

  return (
    <div className={cx('fileUploadArea')}>
      <PortfolioUpload attachFilesField={attachFilesField} />
    </div>
  );
};

export default CareerAttachFiles;
